import { useResponsive } from '../hooks/useResponsive';
import { useAppState } from '../context/AppStateContext';
import Sidebar from '../components/layout/Sidebar';
import GlobalHeader from '../components/layout/GlobalHeader';
import MarketplaceTab from '../components/tabs/MarketplaceTab';
import NotificationsPanel from '../components/shared/NotificationsPanel';
import GuestPromptDrawer from '../components/shared/GuestPromptDrawer';

export default function MarketplacePage() {
  const { isDesktop } = useResponsive();
  const { showNotifications, setShowNotifications } = useAppState();

  if (isDesktop) {
    return (
      <div className="flex h-screen h-dvh bg-gray-50">
        <Sidebar />
        <main className="flex-1 flex flex-col overflow-hidden ml-64">
          <GlobalHeader />
          <div className="flex-1 overflow-y-auto scrollbar-hide">
            <MarketplaceTab />
          </div>
        </main>

        {showNotifications && (
          <NotificationsPanel onClose={() => setShowNotifications(false)} />
        )}

        <GuestPromptDrawer />
      </div>
    );
  }

  // Mobile: No BottomNav for marketplace - full immersive shopping experience
  return (
    <div className="flex flex-col h-screen h-dvh bg-gray-50">
      <main className="flex-1 flex flex-col overflow-hidden">
        <MarketplaceTab />
      </main>

      {showNotifications && (
        <NotificationsPanel onClose={() => setShowNotifications(false)} />
      )}

      <GuestPromptDrawer />
    </div>
  );
}
